module.exports = __webpack_public_path__ + "img/nathananderson.a4d1c4c5.png";